import { adminTranslations } from './translations/admin';
import { adminOperationsTranslations } from './translations/adminOperations';
import { adminRequestsTranslations } from './translations/adminRequests';
import { adminProjectsTranslations } from './translations/adminProjects';
import { radarTranslations } from './translations/radar';
import { analyticsTranslations } from './translations/analytics';
import { forumTranslations } from './translations/forum';
import { customerTranslations } from './translations/customer';
import { contentTranslations } from './translations/content';
import { customizerTranslations } from './translations/customizer';
import { customDesignTranslations } from './translations/customDesign';
import { communityTranslations } from './translations/community';
import { homeTranslations } from './translations/home';
import { storeTranslations } from './translations/store';

const en = {
  'language.label': 'Language',
  'language.select': 'Select language',
  'language.current': 'Current language: {{language}}',
  'header.logoAlt': 'YCH-YOYO logo',
  'header.account': 'Account',
  'header.logout': 'Logout',
  'header.login': 'Login',
  'header.register': 'Register',
  'header.cart': 'Cart',
  'nav.home': 'Home',
  'nav.store': 'Store',
  'nav.customYoyo': 'Custom Yoyo',
  'nav.customDesign': 'Custom Design',
  'nav.team': 'Team',
  'nav.stories': 'Stories',
  'nav.community': 'Community',
  'nav.guide': 'Guide',
  'nav.shipping': 'Shipping',
  'nav.contact': 'Contact Us',
  'badge.featured': 'FEATURED',
  'badge.new': 'NEW',
  'footer.shipping': 'Shipping',
  'footer.contact': 'Contact Us',
  'modal.close': 'Close',
  'app.orderSuccess': 'Order placed! You will receive an email confirmation.',
  'app.orderCanceled': "Order canceled. Continue shopping and check out when you're ready.",
  'seo.defaultDescription': 'Official website of YCH-YOYO. Discover competition-level yo-yos, accessories, and team stories.',
};

const ja = {
  'language.label': '言語',
  'language.select': '言語を選択',
  'language.current': '現在の言語：{{language}}',
  'header.logoAlt': 'YCH-YOYO ロゴ',
  'header.account': 'アカウント',
  'header.logout': 'ログアウト',
  'header.login': 'ログイン',
  'header.register': '新規登録',
  'header.cart': 'カート',
  'nav.home': 'ホーム',
  'nav.store': 'ストア',
  'nav.customYoyo': 'カスタムヨーヨー',
  'nav.customDesign': 'カスタムデザイン',
  'nav.team': 'チーム',
  'nav.stories': 'ストーリー',
  'nav.community': 'コミュニティ',
  'nav.guide': 'ガイド',
  'nav.shipping': '配送',
  'nav.contact': 'お問い合わせ',
  'badge.featured': 'おすすめ',
  'badge.new': '新着',
  'footer.shipping': '配送',
  'footer.contact': 'お問い合わせ',
  'modal.close': '閉じる',
  'app.orderSuccess': 'ご注文を受け付けました。確認メールをお送りします。',
  'app.orderCanceled': '注文はキャンセルされました。準備ができましたら、引き続きお買い物をお楽しみください。',
  'seo.defaultDescription': 'YCH-YOYO公式サイト。競技用ヨーヨー、アクセサリー、チームストーリーをご覧ください。',
};

const zhCN = {
  'language.label': '语言',
  'language.select': '选择语言',
  'language.current': '当前语言：{{language}}',
  'header.logoAlt': 'YCH-YOYO 标志',
  'header.account': '账户',
  'header.logout': '退出登录',
  'header.login': '登录',
  'header.register': '注册',
  'header.cart': '购物车',
  'nav.home': '首页',
  'nav.store': '商店',
  'nav.customYoyo': '定制悠悠球',
  'nav.customDesign': '定制设计',
  'nav.team': '团队',
  'nav.stories': '故事',
  'nav.community': '社区',
  'nav.guide': '指南',
  'nav.shipping': '配送',
  'nav.contact': '联系我们',
  'badge.featured': '精选',
  'badge.new': '全新',
  'footer.shipping': '配送',
  'footer.contact': '联系我们',
  'modal.close': '关闭',
  'app.orderSuccess': '订单已提交！您将收到确认邮件。',
  'app.orderCanceled': '订单已取消。您可以继续选购，准备好后再结账。',
  'seo.defaultDescription': 'YCH-YOYO 官方网站。探索竞赛级悠悠球、配件和团队故事。',
};

const zhTW = {
  'language.label': '語言',
  'language.select': '選擇語言',
  'language.current': '目前語言：{{language}}',
  'header.logoAlt': 'YCH-YOYO 標誌',
  'header.account': '帳戶',
  'header.logout': '登出',
  'header.login': '登入',
  'header.register': '註冊',
  'header.cart': '購物車',
  'nav.home': '首頁',
  'nav.store': '商店',
  'nav.customYoyo': '客製溜溜球',
  'nav.customDesign': '客製設計',
  'nav.team': '團隊',
  'nav.stories': '故事',
  'nav.community': '社群',
  'nav.guide': '指南',
  'nav.shipping': '配送',
  'nav.contact': '聯絡我們',
  'badge.featured': '精選',
  'badge.new': '全新',
  'footer.shipping': '配送',
  'footer.contact': '聯絡我們',
  'modal.close': '關閉',
  'app.orderSuccess': '訂單已送出！您將收到確認電子郵件。',
  'app.orderCanceled': '訂單已取消。您可以繼續選購，準備好後再結帳。',
  'seo.defaultDescription': 'YCH-YOYO 官方網站。探索競賽級溜溜球、配件與團隊故事。',
};

const fr = {
  'language.label': 'Langue',
  'language.select': 'Choisir la langue',
  'language.current': 'Langue actuelle : {{language}}',
  'header.logoAlt': 'Logo YCH-YOYO',
  'header.account': 'Compte',
  'header.logout': 'Se déconnecter',
  'header.login': 'Se connecter',
  'header.register': "S'inscrire",
  'header.cart': 'Panier',
  'nav.home': 'Accueil',
  'nav.store': 'Boutique',
  'nav.customYoyo': 'Yo-yo personnalisé',
  'nav.customDesign': 'Conception sur mesure',
  'nav.team': 'Équipe',
  'nav.stories': 'Histoires',
  'nav.community': 'Communauté',
  'nav.guide': 'Guide',
  'nav.shipping': 'Livraison',
  'nav.contact': 'Nous contacter',
  'badge.featured': 'À LA UNE',
  'badge.new': 'NOUVEAU',
  'footer.shipping': 'Livraison',
  'footer.contact': 'Nous contacter',
  'modal.close': 'Fermer',
  'app.orderSuccess': 'Commande passée ! Vous recevrez un e-mail de confirmation.',
  'app.orderCanceled': 'Commande annulée. Continuez vos achats et passez commande quand vous serez prêt.',
  'seo.defaultDescription': "Site officiel de YCH-YOYO. Découvrez des yo-yos de compétition, des accessoires et les histoires de l'équipe.",
};

const es = {
  'language.label': 'Idioma',
  'language.select': 'Seleccionar idioma',
  'language.current': 'Idioma actual: {{language}}',
  'header.logoAlt': 'Logotipo de YCH-YOYO',
  'header.account': 'Cuenta',
  'header.logout': 'Cerrar sesión',
  'header.login': 'Iniciar sesión',
  'header.register': 'Registrarse',
  'header.cart': 'Carrito',
  'nav.home': 'Inicio',
  'nav.store': 'Tienda',
  'nav.customYoyo': 'Yo-yo personalizado',
  'nav.customDesign': 'Diseño personalizado',
  'nav.team': 'Equipo',
  'nav.stories': 'Historias',
  'nav.community': 'Comunidad',
  'nav.guide': 'Guía',
  'nav.shipping': 'Envíos',
  'nav.contact': 'Contacto',
  'badge.featured': 'DESTACADO',
  'badge.new': 'NUEVO',
  'footer.shipping': 'Envíos',
  'footer.contact': 'Contacto',
  'modal.close': 'Cerrar',
  'app.orderSuccess': '¡Pedido realizado! Recibirás un correo electrónico de confirmación.',
  'app.orderCanceled': 'Pedido cancelado. Sigue comprando y finaliza el pedido cuando estés listo.',
  'seo.defaultDescription': 'Sitio web oficial de YCH-YOYO. Descubre yo-yos de competición, accesorios e historias del equipo.',
};

const ko = {
  'language.label': '언어',
  'language.select': '언어 선택',
  'language.current': '현재 언어: {{language}}',
  'header.logoAlt': 'YCH-YOYO 로고',
  'header.account': '계정',
  'header.logout': '로그아웃',
  'header.login': '로그인',
  'header.register': '회원가입',
  'header.cart': '장바구니',
  'nav.home': '홈',
  'nav.store': '스토어',
  'nav.customYoyo': '커스텀 요요',
  'nav.customDesign': '맞춤 디자인',
  'nav.team': '팀',
  'nav.stories': '스토리',
  'nav.community': '커뮤니티',
  'nav.guide': '가이드',
  'nav.shipping': '배송',
  'nav.contact': '문의하기',
  'badge.featured': '추천',
  'badge.new': '신규',
  'footer.shipping': '배송',
  'footer.contact': '문의하기',
  'modal.close': '닫기',
  'app.orderSuccess': '주문이 완료되었습니다! 확인 이메일을 보내드립니다.',
  'app.orderCanceled': '주문이 취소되었습니다. 쇼핑을 계속하고 준비되면 결제해 주세요.',
  'seo.defaultDescription': 'YCH-YOYO 공식 웹사이트. 대회용 요요, 액세서리와 팀 스토리를 만나보세요.',
};

export const translations = {
  en: { ...adminTranslations.en, ...adminOperationsTranslations.en, ...adminRequestsTranslations.en, ...adminProjectsTranslations.en, ...analyticsTranslations.en, ...radarTranslations.en, ...en, ...customerTranslations.en, ...homeTranslations.en, ...storeTranslations.en, ...contentTranslations.en, ...customizerTranslations.en, ...customDesignTranslations.en, ...communityTranslations.en, ...forumTranslations.en },
  ja: { ...adminTranslations.ja, ...adminOperationsTranslations.ja, ...adminRequestsTranslations.ja, ...adminProjectsTranslations.ja, ...analyticsTranslations.ja, ...radarTranslations.ja, ...ja, ...customerTranslations.ja, ...homeTranslations.ja, ...storeTranslations.ja, ...contentTranslations.ja, ...customizerTranslations.ja, ...customDesignTranslations.ja, ...communityTranslations.ja, ...forumTranslations.ja },
  'zh-CN': { ...adminTranslations['zh-CN'], ...adminOperationsTranslations['zh-CN'], ...adminRequestsTranslations['zh-CN'], ...adminProjectsTranslations['zh-CN'], ...analyticsTranslations['zh-CN'], ...radarTranslations['zh-CN'], ...zhCN, ...customerTranslations['zh-CN'], ...homeTranslations['zh-CN'], ...storeTranslations['zh-CN'], ...contentTranslations['zh-CN'], ...customizerTranslations['zh-CN'], ...customDesignTranslations['zh-CN'], ...communityTranslations['zh-CN'], ...forumTranslations['zh-CN'] },
  'zh-TW': { ...adminTranslations['zh-TW'], ...adminOperationsTranslations['zh-TW'], ...adminRequestsTranslations['zh-TW'], ...adminProjectsTranslations['zh-TW'], ...analyticsTranslations['zh-TW'], ...radarTranslations['zh-TW'], ...zhTW, ...customerTranslations['zh-TW'], ...homeTranslations['zh-TW'], ...storeTranslations['zh-TW'], ...contentTranslations['zh-TW'], ...customizerTranslations['zh-TW'], ...customDesignTranslations['zh-TW'], ...communityTranslations['zh-TW'], ...forumTranslations['zh-TW'] },
  fr: { ...adminTranslations.fr, ...adminOperationsTranslations.fr, ...adminRequestsTranslations.fr, ...adminProjectsTranslations.fr, ...analyticsTranslations.fr, ...radarTranslations.fr, ...fr, ...customerTranslations.fr, ...homeTranslations.fr, ...storeTranslations.fr, ...contentTranslations.fr, ...customizerTranslations.fr, ...customDesignTranslations.fr, ...communityTranslations.fr, ...forumTranslations.fr },
  es: { ...adminTranslations.es, ...adminOperationsTranslations.es, ...adminRequestsTranslations.es, ...adminProjectsTranslations.es, ...analyticsTranslations.es, ...radarTranslations.es, ...es, ...customerTranslations.es, ...homeTranslations.es, ...storeTranslations.es, ...contentTranslations.es, ...customizerTranslations.es, ...customDesignTranslations.es, ...communityTranslations.es, ...forumTranslations.es },
  ko: { ...adminTranslations.ko, ...adminOperationsTranslations.ko, ...adminRequestsTranslations.ko, ...adminProjectsTranslations.ko, ...analyticsTranslations.ko, ...radarTranslations.ko, ...ko, ...customerTranslations.ko, ...homeTranslations.ko, ...storeTranslations.ko, ...contentTranslations.ko, ...customizerTranslations.ko, ...customDesignTranslations.ko, ...communityTranslations.ko, ...forumTranslations.ko },
};
